import { useEffect, useState } from 'react';

export function useContextProviderState<T extends object>(stateObject: T) {
    const [state, setState] = useState(stateObject);

    useEffect(() => {
        setState(stateObject);
    }, Object.values(stateObject));

    return state;
}
